module.exports = __webpack_public_path__ + "media/images/guide-thumb-7t-e0e94de0c7c506d056f9614bbef964b8.png";